export class ShowLoader {
    static readonly type = '[Loader] Show';
  }
  
  export class HideLoader {
    static readonly type = '[Loader] Hide';
  }